export const LIVE_REMOTE_ENABLED = true

export const LIVE_REMOTE_HEARTBEAT_INTERVAL_MS = 25000
export const LIVE_REMOTE_HEARTBEAT_STALE_MS = 60000
